import { render, staticRenderFns } from "./square-fees.vue?vue&type=template&id=074b115c&scoped=true&"
import script from "./square-fees.vue?vue&type=script&lang=js&"
export * from "./square-fees.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "074b115c",
  null
  
)

export default component.exports